require('./bootstrap');

window.Vue = require('vue');
window.VueRouter = require('vue-router').default;
window.Vuex = require('vuex').default;

window.navigatedBack = false
window.onpopstate = function(event) {   // also processes fwd
    window.navigatedBack = true
    app.closeModal(false)
};

import Routes from './routes.js'

let cancelRqRs
// todo: move session here when be storage set
// const session = {}

// import routes
Vue.use(VueRouter)

// import state management
Vue.use(Vuex)

// Templates
const MainDiv = Vue.component('main-div', require('./templates/main_div.vue').default)
const ModalDiv = Vue.component('modal-container', require('./templates/modal_container.vue').default)
const PromptDiv = Vue.component('prompt-div', require('./templates/prompt_div.vue').default)
const ControlsDiv = Vue.component('controls-div', require('./templates/controls_div.vue').default)
const TransitionDiv = Vue.component('transition-div', require('./templates/transition_div.vue').default)
// tags
const LabelTag = Vue.component('label-tag', require('./templates/tags/label_tag.vue').default)
const IconTag = Vue.component('icon-tag', require('./templates/tags/icon_tag.vue').default)
const PriceTag = Vue.component('price-tag', require('./templates/tags/price_tag.vue').default)
const InfoTag = Vue.component('info-tag', require('./templates/tags/info_tag.vue').default)
// form elements
const Checkbox = Vue.component('checkbox', require('./templates/inputs/checkbox_input.vue').default)
const RadioButton = Vue.component('radiobutton', require('./templates/inputs/radiobutton_input.vue').default)
const Slider = Vue.component('slider', require('./templates/inputs/slider_input.vue').default)
const CheckboxTag = Vue.component('checkbox-tag', require('./templates/inputs/checkbox_tag.vue').default)
const OptionTag = Vue.component('option-tag', require('./templates/inputs/option_tag.vue').default)
// Labels
const PriceRangeLabel = Vue.component('price-range-label', require('./components/labels/PriceRangeLabel.vue').default)
// GA Containers
const GAClick = Vue.component('ga-click', require('./components/ga/ClickContainer.vue').default)
// lists
const ListTwoLiner = Vue.component('list-two-liner', require('./templates/lists/TwoLiner.vue').default)
const ListOneLiner = Vue.component('list-one-liner', require('./templates/lists/OneLiner.vue').default)
const ListIcon = Vue.component('list-icon', require('./templates/lists/Icon.vue').default)
const ListTwoLinerIcon = Vue.component('list-two-liner-icon', require('./templates/lists/TwoLinerIcon.vue').default)
const ListOption = Vue.component('list-option', require('./templates/lists/Option.vue').default)
const ListOptionIcon = Vue.component('list-option-icon', require('./templates/lists/OptionIcon.vue').default)
const ListOptionBoxed = Vue.component('list-option-boxed', require('./templates/lists/OptionBoxed.vue').default)
const ListShortcut = Vue.component('list-shortcut', require('./templates/lists/Shortcut.vue').default)

// Error components
const ErrorDefault = Vue.component('error_default', require('./pages/error/default.vue').default)
const Error401 = Vue.component('error_401', require('./pages/error/401.vue').default)
const Error404 = Vue.component('error_404', require('./pages/error/404.vue').default)
const Error503 = Vue.component('error_503', require('./pages/error/503.vue').default)

// Modals
const Situation = Vue.component('modal_situation', require('./modals/situation.vue').default);
const Preorder = Vue.component('modal_preorder', require('./modals/preorder/main.vue').default);
const PreorderReminder = Vue.component('modal_preorder_reminder', require('./modals/preorder/reminder.vue').default);
const PreorderCancellation = Vue.component('modal_preorder_cancellation', require('./modals/preorder/cancellation.vue').default);
const PreorderConfirmation = Vue.component('modal_preorder_confirmation', require('./modals/preorder/confirmation.vue').default);
const Search = Vue.component('modal_search', require('./modals/search.vue').default);
const FaqModal = Vue.component('modal_faq', require('./modals/faq/main.vue').default);
const NoticeCancelledModal = Vue.component('modal_notice_cancelled', require('./modals/notice/cancelled.vue').default);
const NoticeIneligibleModal = Vue.component('modal_notice_ineligible', require('./modals/notice/ineligible.vue').default);
const NoticeExistingOrderModal = Vue.component('modal_notice_existing_order', require('./modals/notice/existingorder.vue').default);
const BenefitsModal = Vue.component('modal_notice_benefits', require('./modals/notice/benefits.vue').default);
const NoAuthModal = Vue.component('modal_notice_no_auth', require('./modals/notice/no_auth.vue').default);
const DeactivatedProductModal = Vue.component('modal_deactivated_product', require('./modals/deactivated_product.vue').default);
const OtherPreapprovedModal = Vue.component('modal_other_preapproved', require('./modals/notice/other_preapproved.vue').default);
const OtherUnfinishedModal = Vue.component('modal_other_unfinished', require('./modals/notice/other_unfinished.vue').default);
const StoreLocatorModal = Vue.component('modal_store_locator', require('./modals/store_locator/main.vue').default);

// Modules
// Genpos
const PosOfferModal = Vue.component('modal_pos_offer', require('./modules/genpos/modals/pos_offer.vue').default);
const AltOfferModal = Vue.component('modal_alt_offer', require('./modules/genpos/modals/alternative_offer.vue').default);
const GenposUnfinishedModal = Vue.component('modal_unfinished_genpos', require('./modules/genpos/modals/unfinished.vue').default);
const GenposPreapprovedModal = Vue.component('modal_preapproved_genpos', require('./modules/genpos/modals/preapproved.vue').default);

const router = new VueRouter(Routes)

const store = new Vuex.Store({
    state: {
        session: session,
        checkout: {
            page: {},
            product: {},
            selected: {}
        },
        store_locator: {
            city: {},
            province: {},
        },
        financing: false,
    },

    mutations: {
        updateSession (state, payload) {
            Object.keys(payload).forEach(function(key, index) {
                state.session[key] = payload[key]
            })
        },
        createProduct (state, payload) {
            state.checkout.product = payload
        },
        updateCheckoutProduct (state, payload) {
            Object.keys(payload).forEach(function(key, index) {
                state.checkout.product[key] = payload[key]
            })
        },
        updateCheckoutPage (state, payload) {
            Object.keys(payload).forEach(function(key, index) {
                state.checkout.page[key] = payload[key]
            })
        },
        updateCheckoutSelected (state, payload) {
            Object.keys(payload).forEach(function(key, index) {
                state.checkout.selected[key] = payload[key]
            })
        },
        clearCheckoutSelected (state, payload) {
            if(payload) {
                payload.forEach(function(index) {
                    state.checkout.selected[index] = ''
                })
            } else {
                state.checkout.selected = {}
            }
        },

        // store locator
        updateStoreLocator: function(state, payload) {
            state.store_locator.city = _.get(payload, 'city', null);
            state.store_locator.province = _.get(payload, 'province', null);
        },
        clearStoreLocator: function(state, payload) {
            state.store_locator = {
                city: {},
                province: {}
            };
        },
    }
})

// Vendor components
Vue.component('lottie', require('vue-lottie').default)

// Generic components
Vue.component('navbar-subheader', require('./components/NavSubheader.vue').default)
Vue.component('navbar-header', require('./components/NavHeader.vue').default)
Vue.component('modal-header', require('./components/ModalHeader.vue').default)
Vue.component('story-card-flex', require('./components/StoryCardFlex.vue').default)
Vue.component('story-group', require('./components/StoryGroup.vue').default)
Vue.component('product-card-flex', require('./components/ProductCardFlex.vue').default)
Vue.component('campaign-card-flex', require('./components/CampaignCardFlex.vue').default)
Vue.component('campaign-group', require('./components/CampaignCardFlex.vue').default)

// Directives
// v-focus
Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el, binding) {
        if (binding.value)
            el.focus()
    }
})

const app = new Vue({
    el: '#app',
    router,
    store,
    // components: { MainDiv },
    data: {
        isOverlayed: false,
        transitionType: 'slide-left',
        modalOpened: false,
        modalStack: [],
        modalParams: {},
        currentModal: '',
        loadAnimation: require('../js/assets/mpl-loading.json'),
        backToRoute: false,
        defaultAltImage: '/images/icons/icon-gray-homecredit-full.svg',
    },
    computed: {

    },
    watch:{
        $route (to, from) {
            this.$root.triggerPageGEvent(to.fullPath)

            // clear modal stack
            this.modalStack = []

            // reset body class
            // document.body.className = ''

            this.modalOpened = false    // for when nav to error while modal is opened

            // go back until route found
            if(window.navigatedBack && this.backToRoute) {
                if(this.$router.currentRoute.name == this.backToRoute) {
                    cancelRqRs = false
                    this.backToRoute = false
                } else {
                    cancelRqRs = true
                    this.$router.go(-1)
                }
            }

            // reset to default transition
            if(window.navigatedBack) {
                if(from.meta.pageType == 'page')
                    this.transitionType =  'slide-right'
                else
                    this.transitionType =  'slide-down'
                window.navigatedBack = false
            }

            // move to search page
            if(to.name == 'search') {
                if(to.query['focus'] == 'search')
                    this.isOverlayed = true
            }
        }
    },

    created() {
        // todo: call session when be storage set
        // axios
        //     .get("session")
        //     .then(response => {
        //         if(response.data) {
        //             this.$store.commit('updateSession', response.data)
        //         }
        //     })

        // this.$router.onError(() => { alert('error loading page') })

        var vm = this
        axios.interceptors.request.use(
            config => {
                if (cancelRqRs) {
                    return false
                }

                return config
            }
        )

        axios.interceptors.response.use(
            function(response) {
                if (response.data.invalid === true) {
                    if (response.data.silent === true)
                        return response
                    else
                        vm.$router.push({ name: 'error', params: { code: 500 }})
                        // vm.$router.push({ name: 'error', params: { code: _.get(response, 'data.code', 500) }})
                        // vm.$router.replace({ name: 'error'})
                }

                if (cancelRqRs) {
                    return false
                }

                return response;
            },
            function(error) {
                let code = typeof(error.response) == 'undefined' ? 500 : error.response.status
                vm.$router.push({ name: 'error', params: { code: code }})
            }
        );

        // look for location replace payload
        if ((typeof locationReplace !== 'undefined') && (locationReplace.length > 0)) {
            vm.$router.push({ path: locationReplace });
        }

    },

    methods: {
        modalEventCallback(event) {
            this.$refs.mainComponent[event.method](event)
        },

modalEventOldback(args) {
    this.$refs.mainComponent[args.method]([...args.args])

    if(args.closeModal)
        this.$root.closeModal()
},

        showOverlay() {
            if(!this.isOverlayed) {
                this.isOverlayed = true
                document.addEventListener('click', this.hideOverlay)
            }
        },

        hideOverlay() {
            if(this.isOverlayed) {
                this.isOverlayed = false
                document.removeEventListener('click', this.hideOverlay)
            }
        },

        goBackTo(prev) {
            if(typeof prev === 'number') {
                this.$router.go(0 - parseInt(prev))
            } else {
                if (typeof prev === 'string') {
                    this.backToRoute = prev
                }

                this.$router.go(-1)
            }
        },

        goForwardTo(next) {
            if (typeof next === 'string')
                this.$router.push(next)
        },

        updateState() {
            axios
                .get("session")
                .then(response => {
                    if(response.data) {
                        let session = {
                            canCheckout: response.data.canCheckout,
                            tagDescription: response.data.tagDescription,
                            noticeDetails: response.data.noticeDetails,
                        }

                        this.$store.commit('updateSession', session)
                    }
                })
        },

        openModal(component, params, modal) {
            var query = {...this.$route.query, hasModal: component}
            var queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&')   // create query string
            history.pushState('', component, this.$route.path + '?' + queryString)

            if(modal) {
                this.modalStack.push(modal);
            }

            this.currentModal = component
            this.modalParams = params
            this.modalOpened = true
        },

        closeModal(event) {
            this.currentModal = ''
            this.modalOpened = false

            let stack = this.modalStack.length
            if(stack) {
                let modal = this.modalStack.pop()
                this.openModal(modal[0], modal[1])
            } else {
                if(event === false) {
                    return  // important! avoids loop
                }

                this.goBackTo(1)
            }

        },

        triggerPageGEvent(page, params=false) {
            let stringParams = ''

            if(params) {
                _.forEach(params, function(value, key) {
                    stringParams = stringParams + key + '=' + value + '&'
                })

                stringParams = _.trimEnd('?' + stringParams, '&')
            }

            ga('set', 'page', '/' + _.trimStart(page + stringParams, '/'))
            ga('send', 'pageview')

            // GA4
            if (typeof gtag === 'function') {
                gtag('config', GTAGMID, {
                    'page_path': '/' + _.trimStart(page + stringParams, '/')
                });
            } else {
                console.log('GTAG Func Not Defined');
            }
        },

        triggerG4Event(name, params = {}) {
            if (typeof gtag === 'function') {
                gtag("event", name, params)
            } else {
                console.log('GTAG Func Not Defined');
            }
        },

        imageAlt: function(e, src = null) {
            e.target.src = src ?? this.defaultAltImage
        },

        formatCurrency(amount, noDec = true) {
            // force float
            let amountRounded = parseFloat(amount);

            if(amountRounded % 1 != 0) {
                amountRounded = noDec? Math.ceil(amount) : parseFloat(amount).toFixed(2)
            }
            return '₱' + amountRounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        displayAsPercent(decimalVal) {

            // if zero val or negative
            if (decimalVal <= 0) {
                return '0%';
            }

            // shorten the decimal value to up to 5 decimal places
            let shortVal = parseFloat(parseInt((decimalVal + Number.EPSILON) * 100000) / 100000)

            // convert to percentage, up to 3 decimal places
            let percentageVal = (shortVal * 100).toFixed(3)

            // finally, if percentageVal has trailing zeroes, this will remove it
            let displayVal = parseFloat(percentageVal).toString()

            return displayVal + "%";
        },

        // slugify(string) {
        //     return string.toString().toLowerCase()
        //         .replace(/\s+/g, '-') // Replace spaces with -
        //         .replace(/&/g, '-and-') // Replace & with 'and'
        //         .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        //         .replace(/\-\-+/g, '-') // Replace multiple - with single -
        //         .replace(/^-+/, '') // Trim - from start of text
        //         .replace(/-+$/, '') // Trim - from end of text
        // }

        visibleX(el){
            let rect = el.getBoundingClientRect();
            // element rect left
            let left = rect.left;
            // element rect center
            let center = (rect.width / 2);

            // Check its within the document viewport
            return (left + center) <= document.documentElement.clientWidth;
        },

        sendCarouselClickGa: function(position, carouselCategory, product = false) {

            var eventLabel = position;

            if (product !== false) {
                eventLabel = position
                    + ' - '
                    + product.productName
                    + ((product.hasOwnProperty('shortDesc')) ? ' ' + product.shortDesc : '');
            }

            ga('send', {
                hitType: 'event',
                eventCategory: carouselCategory,
                eventAction: 'Click',
                eventLabel: eventLabel,
            });
        },

        sendSwipeGa: function(swipeEvent) {
            let carouselElement = swipeEvent.currentTarget;

            this.carouselScrollEvent(carouselElement).then(() => {
                ga('send', {
                    hitType: 'event',
                    eventCategory: carouselElement.getAttribute('gaCarouselCategory'),
                    eventAction: 'Swipe',
                    eventLabel: carouselElement.getAttribute('lastVisiblePosition').toString(),
                });
            });
        },

        carouselScrollEvent: function(carouselElement) {
            let self = this; // preserve self
            let lastVisiblePosition = carouselElement.getAttribute('lastVisiblePosition');
            return new Promise((resolve, reject) => {
                carouselElement.querySelectorAll('.carousel--item').forEach((item, key) => {
                    if (item.getAttribute('isVisible') === null && self.visibleX(item)) {
                        // set as visible
                        item.setAttribute('isVisible', 1);

                        // updating to lastVisiblePosition
                        if ((key + 1) > lastVisiblePosition) {
                            // new key
                            lastVisiblePosition = (key + 1);

                            // update carousel element
                            carouselElement.setAttribute('lastVisiblePosition', lastVisiblePosition);
                            // resolve
                            resolve();
                        }
                    }
                });
            });
        },

        recordAndroidAnalytics: function(eventName, eventParams, platform) {

            // if public, do not execute
            if (this.isPublicSession()) {
                return;
            }

            try {
                // check if appevents is valid
                if(typeof AppEvents === 'object' && AppEvents !== null) {

                    // check if logevent is valid
                    if (typeof AppEvents.logEvent === 'function') {

                        // check if moenage is compatible
                        if(this.$store.state.session.moengageCompatible) {
                            AppEvents.logEvent(eventName, JSON.stringify(eventParams), JSON.stringify({platform: platform}))
                        } else {
                            // 9.3 and below - appsflyer only
                            AppEvents.logEvent(eventName, JSON.stringify(eventParams))
                        }
                    }
                } else {
                    console.log('no AppEvents found')
                }
            } catch (e) {
                console.log('Appevent logevent inaccessible');
            }
        },

        isPublicSession: function() {
            return (this.$store.state.session.tagDescription == 'public')
        },

        getExitLocation: function() {

            if (! this.isPublicSession()) {
                // logged in
                return "exit?location=dashboard"
            } else {
                // public
                return "exit?location=launcher"
            }
        }
    },
}).$mount('#app')

router.beforeEach((to, from, next) => {
    if(_.get(to, 'query.hasModal', false)) {
        if(!app.modalOpened) {  // modalStack is empty
            app.goBackTo(1)
        }
        next(false)
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    if(to.meta.pageType == 'modal')
        app.transitionType = 'slide-up'
    else
        app.transitionType = 'slide-left'
})
